import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Inbox, FileText, SlidersHorizontal } from "lucide-react";
import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import Logo from "../components/Logo";
import LeadsPanel from "../components/admin/LeadsPanel";
import BlogManager from "../components/admin/BlogManager";
import FormBuilder from "../components/admin/FormBuilder";
import { API, authConfig, axios, isAuthed, clearToken } from "../lib/auth";

const Admin = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  const logout = () => { clearToken(); navigate("/admin/login"); };

  useEffect(() => {
    if (!isAuthed()) { navigate("/admin/login"); return; }
    axios.get(`${API}/admin/me`, authConfig())
      .then(() => setChecking(false))
      .catch(() => { clearToken(); navigate("/admin/login"); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checking) {
    return <div className="min-h-screen bg-slate-50 flex items-center justify-center text-slate-400">Loading dashboard...</div>;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="navy-gradient">
        <div className="mx-auto max-w-7xl px-6 py-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Logo light />
            <span className="hidden sm:inline text-blue-200/70 text-sm font-semibold border-l border-blue-300/30 pl-4">Dashboard</span>
          </div>
          <Button onClick={logout} variant="secondary" className="font-semibold">
            <LogOut className="mr-2 h-4 w-4" /> Log out
          </Button>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 py-8">
        <Tabs defaultValue="leads">
          <TabsList className="mb-8">
            <TabsTrigger value="leads" className="font-semibold"><Inbox className="mr-2 h-4 w-4" />Leads</TabsTrigger>
            <TabsTrigger value="blog" className="font-semibold"><FileText className="mr-2 h-4 w-4" />Blog</TabsTrigger>
            <TabsTrigger value="form" className="font-semibold"><SlidersHorizontal className="mr-2 h-4 w-4" />Form</TabsTrigger>
          </TabsList>
          <TabsContent value="leads"><LeadsPanel onAuthError={logout} /></TabsContent>
          <TabsContent value="blog"><BlogManager onAuthError={logout} /></TabsContent>
          <TabsContent value="form"><FormBuilder onAuthError={logout} /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default Admin;
